
import React from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Typography, Button, Paper, Box } from '@mui/material';

function TempCheckoutPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { cart } = location.state || { cart: [] };

  // Recreate the line_items structure for display
  const line_items = cart.map(item => {
    return {
      price_data: {
        currency: 'usd',
        product_data: {
          name: item.raceName,
          // In a real scenario, you might want to show the image URL
          // images: [`https://s3.REGION.amazonaws.com/BUCKET/photos/thumb/${encodeURIComponent(item.thumbnail_filename)}`],
        },
        unit_amount: item.price * 100,
      },
      quantity: 1,
    };
  });

  const stripe_json = {
    line_items: line_items,
    metadata: {
      image_ids: cart.map(item => item.id).join(','),
    }
  }

  const handleSuccess = async () => {
    try {
      await axios.post('/api/users/simulate-purchase', { cart });
      navigate('/success', { state: { cart: cart } }); 
    } catch (error) {
      console.error('Error simulating purchase:', error);
      alert('There was an error simulating the purchase.');
    }
  };

  const handleFailure = () => {
    alert('Simulating a failed purchase.');
    navigate('/cart');
  };

  return (
    <Container maxWidth="md">
      <Typography variant="h4" component="h1" gutterBottom>
        Simulated Stripe Checkout
      </Typography>
      <Typography variant="body1" gutterBottom>
        This is a temporary page to simulate the checkout process. Below is the JSON data that would be sent to Stripe.
      </Typography>
      
      <Paper elevation={3} sx={{ p: 2, my: 2, backgroundColor: '#f5f5f5' }}>
        <Typography variant="h6" component="h2">
          Stripe JSON Payload
        </Typography>
        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
          {JSON.stringify(stripe_json, null, 2)}
        </pre>
      </Paper>

      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 2 }}>
        <Button variant="contained" color="success" onClick={handleSuccess}>
          Simulate Successful Purchase
        </Button>
        <Button variant="contained" color="error" onClick={handleFailure}>
          Simulate Purchase Failure
        </Button>
      </Box>
    </Container>
  );
}

export default TempCheckoutPage;
